import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setIsMouseOver, setTooltipData } from "@/store/slices/GlobalSlice";

const { Option } = Select;

const BtnTownDropDown = (props) => {
  const dispatch = useDispatch();
  const { townList } = useSelector((state) => state.globalSlice);

  const handleChange = (value) => {
    console.log(`selected ${value}`);

    let outerIframe = window.parent;
    const isMobile = outerIframe.innerWidth <= 768;

    const toolTipPortion = document.querySelector(".tooltip-portion");

    const currentTown = townList.find((town) => town.term_id === value);
    const townElement = document.querySelector(
      `[data-townid='${currentTown.id}']`
    );

    const townElementPosition = townElement.getBoundingClientRect();

    dispatch(setIsMouseOver());
    dispatch(setTooltipData(parseInt(currentTown.id)));

    if (isMobile) return;

    toolTipPortion.setAttribute(
      "style",
      `
      top: ${
        townElementPosition.y -
        toolTipPortion.clientHeight -
        townElementPosition.height / 5
      }px;
      left: ${
        townElementPosition.right -
        toolTipPortion.clientWidth / 2 -
        townElementPosition.width / 2
      }px;
      opacity: 1;
      pointer-events: auto;
      `
    );
  };

  return (
    <div className="form_upload_wrapper px-5 mb-9 md:hidden">
      <Select
        placeholder="Select Town"
        style={{ width: "100%" }}
        onChange={handleChange}
      >
        {townList?.map((item) => (
          <Option key={item.term_id} value={item.term_id}>
            {item.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

BtnTownDropDown.propTypes = {};

export default BtnTownDropDown;
